<script>
import { merchantComputed, setComputed, authComputed } from '@state/helpers'

import ModalShare from '@components/modal/ModalShare';
import ModalLogin from '@components/modal/ModalLogin';

export default {
  components: {
    ModalShare,
    ModalLogin
  },
  data() {
    return {
      isModalShareActive: false,
      isModalLoginActive: false,
      defaultAvatar: require('@assets/images/avatar_default.png'),
      defaultAvatarFemale: require('@assets/images/avatar_default_female.png'),
      defaultAvatarMale: require('@assets/images/avatar_default_male.png'),
      defaultLogo: require('@assets/images/logo_default.png'),
      hostname: `${location.protocol}//${window.location.hostname}`,
      isShareModalActive: false,
      copyBtn: null, // 存储初始化复制按钮事件
    }
  },
  computed: {
    ...merchantComputed,
    ...setComputed,
    ...authComputed,
    merchant() {
      return this.currentMerchant || {
        alias: '',
        name: ''
      }
    },
    merchantAlias() {
      return this.$route.params.merchantAlias || this.currentMerchant.alias;
    }
  },
  methods: {
    openShareModal() {
      this.isModalShareActive = true;
    },
    openLoginModal() {
      this.isModalLoginActive = true;
    },
    setLanguage(lang) {
      if (lang !== this.currentLanguage) {
        window.location = `${this.$route.path}?language=${lang}`
      }
    },
    onLogout() {
      this.$store.dispatch('auth/logOut', this.merchantAlias);

      if(this.$route.meta.authRequired) {
        if(this.merchant.alias) {
          this.$router.push({
            name: 'home',
            params: { merchantAlias: this.merchant.alias },
            query: {
              language: this.$route.query.language,
            }
          })
        }else {
          window.location.href = '/'
        }
      }

      // this.$toast.open(this.$t('登出成功'));
    },
    handleLogin() {
      if(this.$route.name === '404') {
        this.$router.push(this.$route.query.redirectFrom || { name: 'member-order', query: {
            language: this.$route.query.language,
          }})
      }
    },
    formatLanguage(lang) {
      const langList = {
        en: 'Engilsh',
        'zh-hant': '繁體中文',
      };

      return langList[lang]
    },
  },
}
</script>

<template>
  <header :class="$style.header">
    <div :class="$style.sticky" class="navbar" role="navigation" aria-label="main navigation">
      <div :class="$style.navbar" class="navbar-brand">
        <div class="navbar-item">
          <picture :class="$style.logoImg">
            <BaseImage :src="merchant.logo" :error-src="defaultLogo" :rel="false" class-name="is-cover" />
          </picture>
          <!--<div :class="$style.logoImg" :style="{ backgroundImage: `url(${merchant.logo})` }"></div>-->
          <router-link
            v-if="!$route.meta.showDingSomethingLogo && merchant.alias"
            :class="$style.logoName"
            class="is-link-primary"
            :to="{ name: 'home', params: { merchantAlias: merchant.alias },
            query: { language: $route.query.language } }"
          >{{merchant.name}}</router-link>
          <span v-else class="is-link-primary" :class="$style.logoName">i 保庇</span>
        </div>
        <div class="navbar-item">
          <div class="navbar is-demarcation-stlye is-right" :class="$style.navbarItem">
            <div v-if="currentMerchant && $route.meta.showShareButton" :class="$style.shareButton" class="navbar-item">
              <b-button class="is-small-circle" @click="openShareModal">
                <BaseIcon name="share-alt" />
              </b-button>
            </div>
            <div v-if="$route.meta.showLoginButton" class="navbar-item">
              <b-dropdown v-if="loggedIn" hoverable position="is-bottom-left" aria-role="list">
                <b-button slot="trigger" class="is-small-circle">
                  <BaseIcon icon-style="fas" name="user" />
                </b-button>
                <b-dropdown-item
                  has-link
                  aria-role="listitem"
                >
                  <router-link
                    :to="{ name: 'member-order', params: { merchantAlias: merchantAlias }, query: { language: $route.query.language, merchant: $route.query.merchant } }"
                  >
                    {{ $t('global.MEMBER_ORDER'/*我的結緣*/) }}
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item separator></b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="onLogout">
                  {{ $t('global.LOGOUT'/*登出*/) }}
                </b-dropdown-item>
              </b-dropdown>
              <b-button v-else class="is-small-circle" @click="openLoginModal">
                <BaseIcon name="user" />
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.roof"></div>
    </div>
    <b-modal
      :active.sync="isModalShareActive"
      :width="650"
      :can-cancel="['escape','outside']">
      <ModalShare @close="isModalShareActive = false"/>
    </b-modal>
    <b-modal
      :active.sync="isModalLoginActive"
      :width="370"
      :can-cancel="['escape','outside']">
      <ModalLogin @close="isModalLoginActive = false" @login="handleLogin"/>
    </b-modal>
  </header>
</template>

<style lang="scss" module>
.header {
  position: relative;
  height: 0;
  padding-bottom: 75px;
  // z-index: 7;
  @include touch {
    padding-bottom: 60px;
  }

  @include mobile{
    padding-bottom: 57px;
  }
  .sticky {
    position: fixed;
    top: 0;
    width: 97%;
    width: calc(100% - 100px);
    padding: 15px 0 0;
    margin: 0 50px;
    background-image: url(@assets/images/header/roof_center.png);
    -webkit-box-shadow: 0 0 50px 0 rgba(32, 32, 32, 0.15);
    box-shadow: 0 0 50px 0 rgba(32, 32, 32, 0.15);

    @include touch {
      top: -14px;
      width: 100%;
      padding: 15px 0.5em 0;
      margin: 0;
    }
    &::before {
      position: absolute;
      top: 0;
      left: -70px;
      width: 70px;
      height: 100%;
      content: '';
      background-image: url(@assets/images/header/roof_left.png);

      @include touch {
        display: none;
      }
    }
    &::after {
      position: absolute;
      top: 0;
      right: -70px;
      width: 70px;
      height: 100%;
      content: '';
      background-image: url(@assets/images/header/roof_right.png);

      @include touch {
        display: none;
      }
    }
    .roof {
      position: absolute;
      bottom: -26px;
      left: -58px;
      z-index: 1;
      width: 101vw;
      height: 30px;
      background-image: url(@assets/images/header/roof_bottom.png);

      @include touch {
        display: none;
      }
    }
  }
}

.logoImg {
  width: 35px;
  height: 34px;
  margin-right: 0.5rem;
  overflow: hidden;
  background-position: center;
  border-radius: 100%;
  img {
    max-height: none;
  }

  @include touch {
    display: none;
  }
}

.logoName {
  @include font-datk8;

  font-size: 20px;
  letter-spacing: 0.1em;
  white-space: nowrap;

  @include touch {
    font-size: 17px;
  }
}

.navbar {
  justify-content: space-between;
  width: 100%;
}

.navbarItem {
  background: transparent;
}

.shar-icon {
  margin-bottom: 0.5rem;
}

.shareButton {
  @include mobile {
    display: none !important;
  }
}

.member-avatar {
  position: relative;
  box-sizing: content-box;
  display: inline-block;
  width: 37px;
  height: 37px;
  overflow: hidden;
  cursor: pointer;
  background: #dbdbdb;
  border-radius: 100%;
  img {
    max-height: unset;
  }
}
</style>
